import { render, staticRenderFns } from "./StartUpdatedItem.vue?vue&type=template&id=12f65c98&scoped=true&"
import script from "./StartUpdatedItem.vue?vue&type=script&lang=ts&"
export * from "./StartUpdatedItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f65c98",
  null
  
)

export default component.exports